import { S as Swiper } from './classes-to-selector-6ijYtnfY.js';
import { N as Navigation } from './navigation-D3ssu5k4.js';
import { P as Pagination } from './pagination-6ibxO3Ub.js';
import { S as Scrollbar } from './scrollbar-CigCyCA3.js';
import { A as A11y } from './a11y-DZ2R8bcp.js';
import { M as Manipulation } from './manipulation-DUnmDJcO.js';

/**
 * @class MediaItemsSlider
 * @extends {HTMLElement}
 * @description Create a product media slider, linked to the product variant.
 */
class MediaItemsSlider extends HTMLElement {
  connectedCallback() {
    this.buildSlider();
  }

  /*
   * Create main slider
   */
  buildSlider() {
    // Check if Swiper exists
    if (typeof Swiper === 'undefined') {
      return false;
    }

    // Get swiper element
    this.swiperElement = this.querySelector('[data-swiper]');

    // Swiper options
    this.swiperOptions = {
      modules: [A11y, Navigation, Pagination, Scrollbar, Manipulation],
      threshold: 10,
      direction: 'horizontal',
    };

    // Check if we have extra options on the HTML
    if (this.swiperElement.dataset.options) {
      const options = JSON.parse(this.swiperElement.dataset.options);
      if (options) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...options,
        };
      }
    }

    // Create Main slider
    this.swiperMainInstance = new Swiper(this.swiperElement, this.swiperOptions);

    this.swiperMainInstance.on('activeIndexChange', (event) => {
      this.updatePagination(event.activeIndex + 1);
    });

    // Rebuid Swiper in design mode
    if (Shopify.designMode && this.swiperMainInstance) {
      window.addEventListener('shopify:section:load', () => {
        this.swiperMainInstance.update();
      });
    }
  }

  /**
   * updatePagination
   * @param {Number} amount
   */
  updatePagination(amount) {
    this.querySelector('[data-swiper="active-index"]').textContent = amount;
  }
}

customElements.define('media-items-slider', MediaItemsSlider);
